import { render, staticRenderFns } from "./HttpGet.vue?vue&type=template&id=76845634&"
import script from "./HttpGet.vue?vue&type=script&lang=ts&"
export * from "./HttpGet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../voice.mave.work/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports